import { render } from "./QuestionPage.vue?vue&type=template&id=64114630&scoped=true"
import script from "./QuestionPage.vue?vue&type=script&lang=js"
export * from "./QuestionPage.vue?vue&type=script&lang=js"

import "./QuestionPage.vue?vue&type=style&index=0&id=64114630&lang=css"
import "./QuestionPage.vue?vue&type=style&index=1&id=64114630&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64114630"]])

export default __exports__